import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingButtons from '../../components/feature/FloatingButtons';

export default function FiberServicesPage() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const services = [
    { title: 'Fiber Kablo Tamiri', slug: 'fiber-kablo-tamiri', icon: 'ri-tools-line', description: 'Kesilen veya hasar gören fiber optik kabloların profesyonel onarımı. Fusion splicing yöntemiyle minimum kayıpla tamir.', features: ['Fusion Splicing', 'Mekanik Ek', 'OTDR Test', '7/24 Acil Müdahale'], color: 'blue' },
    { title: 'Fiber Sonlandırma ve Ek', slug: 'fiber-sonlandirma', icon: 'ri-plug-line', description: 'SC, LC, ST konnektör sonlandırma işlemleri. OM3, OM4, OS2 fiber tiplerine uygun profesyonel ek hizmeti.', features: ['SC/LC Konnektör', 'Pigtail Ek', 'Patch Panel', 'ODF Kurulum'], color: 'cyan' },
    { title: 'OTDR Test ve Arıza Tespiti', slug: 'otdr-test', icon: 'ri-line-chart-line', description: 'Fiber optik hatların detaylı analizi ve arıza noktalarının hassas tespiti. Profesyonel OTDR cihazlarıyla ölçüm.', features: ['OTDR Ölçüm', 'Güç Ölçümü', 'Arıza Lokasyonu', 'Raporlama'], color: 'indigo' },
    { title: 'Bina Fiber Altyapı', slug: 'bina-fiber-altyapi', icon: 'ri-building-4-line', description: 'Konut ve iş merkezlerinde fiber optik altyapı kurulumu. Kat dağıtımı, riser kablo çekimi ve sonlandırma.', features: ['Riser Kablo', 'Kat Dağıtımı', 'ODF Kurulum', 'Test ve Devreye Alma'], color: 'violet' },
    { title: 'Fabrika Fiber Çözümleri', slug: 'fabrika-fiber', icon: 'ri-factory-line', description: 'Endüstriyel tesislerde yüksek kapasiteli fiber altyapı. Makine ağları, otomasyon sistemleri için fiber çözümler.', features: ['Endüstriyel Fiber', 'Makine Ağları', 'Yüksek Kapasite', 'Dayanıklı Altyapı'], color: 'purple' },
    { title: '7/24 Acil Fiber Servisi', slug: 'acil-servis', icon: 'ri-24-hours-line', description: 'Kesintisiz hizmet için 7/24 acil fiber arıza müdahale ekibi. İstanbul ve çevre illerde hızlı müdahale garantisi.', features: ['Anında Müdahale', 'Mobil Ekip', 'Yedek Malzeme', 'Hızlı Çözüm'], color: 'sky' },
  ];

  const benefits = [
    { icon: 'ri-shield-check-line', title: 'Sertifikalı Ekip', desc: '10+ yıl deneyimli uzman kadro' },
    { icon: 'ri-time-line', title: 'Hızlı Müdahale', desc: 'Ortalama 2 saat yanıt süresi' },
    { icon: 'ri-tools-line', title: 'Profesyonel Ekipman', desc: 'Son teknoloji OTDR ve fusion cihazları' },
    { icon: 'ri-map-pin-line', title: 'Geniş Hizmet Ağı', desc: 'İstanbul ve 10+ ilde aktif servis' },
  ];

  const locations = ['İstanbul', 'Kocaeli', 'Gebze', 'Tuzla', 'Bursa', 'Sakarya', 'Tekirdağ', 'Yalova', 'Çorlu', 'Dilovası', 'Çayırova', 'Pendik'];

  return (
    <>
      <title>Fiber Optik Hizmetleri İstanbul | Fiber Kablo Tamiri ve Sonlandırma</title>
      <meta name="description" content="İstanbul ve çevre illerde profesyonel fiber optik kablo tamiri, sonlandırma, OTDR test, bina ve fabrika fiber altyapı kurulumu. 7/24 acil fiber servis hizmeti." />
      <meta name="keywords" content="fiber optik, fiber kablo tamiri, fiber sonlandırma, fusion splicing, OTDR test, İstanbul fiber, Kocaeli fiber, bina fiber altyapı, fabrika fiber" />
      <link rel="canonical" href="https://fiberek.com/fiber-hizmetleri" />
      <meta property="og:title" content="Fiber Optik Hizmetleri İstanbul | Profesyonel Fiber Çözümleri" />
      <meta property="og:description" content="İstanbul ve çevre illerde 7/24 fiber optik kablo tamiri, sonlandırma ve altyapı kurulumu hizmeti." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://fiberek.com/fiber-hizmetleri" />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "Service",
            "name": "Fiber Optik Hizmetleri",
            "description": "İstanbul ve çevre illerde profesyonel fiber optik kablo tamiri, sonlandırma, OTDR test, bina ve fabrika fiber altyapı kurulumu. 7/24 acil fiber servis hizmeti.",
            "provider": {
              "@type": "LocalBusiness",
              "name": "Fiber Ek",
              "telephone": "+905537165561",
              "url": "https://fiberek.com",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Güneşli Mah. 1272. Sk. No: 1 İç Kapı No: 7",
                "addressLocality": "Bağcılar",
                "addressRegion": "İstanbul",
                "addressCountry": "TR"
              }
            },
            "areaServed": ["İstanbul", "Kocaeli", "Gebze", "Tuzla", "Bursa", "Sakarya", "Tekirdağ", "Yalova", "Çorlu", "Dilovası", "Çayırova"],
            "serviceType": "Fiber Optik Hizmetleri",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Fiber Optik Hizmetleri",
              "itemListElement": [
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fiber Kablo Tamiri" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fiber Sonlandırma ve Ek" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OTDR Test ve Arıza Tespiti" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Bina Fiber Altyapı" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Fabrika Fiber Çözümleri" } },
                { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "7/24 Acil Fiber Servisi" } }
              ]
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://fiberek.com/" },
              { "@type": "ListItem", "position": 2, "name": "Fiber Hizmetleri", "item": "https://fiberek.com/fiber-hizmetleri" }
            ]
          }
        ]
      })}</script>

      <div className="min-h-screen bg-dark-950">
        <Navbar />

        <section className="relative pt-32 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-dark-950 to-cyan-900/20"></div>
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-blue-500 to-transparent animate-pulse-slow"></div>
            <div className="absolute top-0 right-1/3 w-px h-full bg-gradient-to-b from-transparent via-cyan-500 to-transparent animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
                <i className="ri-flashlight-line text-blue-400"></i>
                <span className="text-blue-400 text-sm font-medium">Profesyonel Fiber Optik Çözümleri</span>
              </div>
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
                İstanbul ve Çevre İllerde
                <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">Fiber Optik Hizmetleri</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Fiber kablo tamiri, sonlandırma, OTDR test ve altyapı kurulumu konusunda 10+ yıllık deneyim. Sertifikalı ekibimizle İstanbul, Kocaeli, Gebze, Bursa ve çevre illerde 7/24 hizmetinizdeyiz.
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <a href="tel:+905537165561" className="inline-flex items-center gap-2 px-8 py-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-300 font-semibold text-lg shadow-lg shadow-blue-500/30 whitespace-nowrap cursor-pointer">
                  <i className="ri-phone-line"></i>Hemen Ara
                </a>
                <a href="https://wa.me/905537165561" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all duration-300 font-semibold text-lg shadow-lg shadow-emerald-500/30 whitespace-nowrap cursor-pointer">
                  <i className="ri-whatsapp-line"></i>WhatsApp
                </a>
              </div>
            </motion.div>
          </div>
        </section>

        <section className="py-20 bg-dark-950">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div ref={ref} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Fiber Optik Hizmetlerimiz</h2>
              <p className="text-lg text-gray-400 max-w-3xl mx-auto">Endüstriyel ve kurumsal fiber optik ihtiyaçlarınız için eksiksiz çözümler sunuyoruz</p>
            </motion.div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <motion.a key={service.slug} href={`/fiber-hizmetleri/${service.slug}`} initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ delay: index * 0.1 }} className="group relative bg-gradient-to-br from-dark-900 to-dark-800 rounded-2xl p-8 border border-white/10 hover:border-blue-500/50 transition-all duration-500 overflow-hidden cursor-pointer">
                  <div className={`absolute inset-0 bg-gradient-to-br from-${service.color}-500/0 to-${service.color}-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>
                  <div className="relative z-10">
                    <div className={`w-16 h-16 bg-${service.color}-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${service.icon} text-3xl text-${service.color}-400`}></i>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-blue-400 transition-colors">{service.title}</h3>
                    <p className="text-gray-400 mb-6 leading-relaxed">{service.description}</p>
                    <ul className="space-y-2 mb-6">
                      {service.features.map((feature) => (
                        <li key={feature} className="flex items-center gap-2 text-sm text-gray-300">
                          <i className="ri-check-line text-blue-400"></i>{feature}
                        </li>
                      ))}
                    </ul>
                    <div className="flex items-center gap-2 text-blue-400 font-semibold group-hover:gap-4 transition-all">
                      Detaylı Bilgi<i className="ri-arrow-right-line"></i>
                    </div>
                  </div>
                </motion.a>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-gradient-to-br from-blue-900/10 via-dark-950 to-cyan-900/10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => (
                <motion.div key={benefit.title} initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}} transition={{ delay: index * 0.1 }} className="text-center">
                  <div className="w-20 h-20 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${benefit.icon} text-4xl text-blue-400`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{benefit.title}</h3>
                  <p className="text-gray-400">{benefit.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-dark-950">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-white mb-4">Hizmet Verdiğimiz Bölgeler</h2>
              <p className="text-gray-400">İstanbul ve çevre illerde fiber optik hizmetleri sunuyoruz</p>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              {locations.map((location) => (
                <a key={location} href={`/bolgeler/${location.toLowerCase().replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's').replace(/ö/g, 'o').replace(/ç/g, 'c')}`} className="px-6 py-3 bg-dark-800 border border-white/10 rounded-lg text-gray-300 hover:border-blue-500 hover:text-blue-400 transition-all duration-300 cursor-pointer whitespace-nowrap">
                  {location}
                </a>
              ))}
            </div>
          </div>
        </section>

        <section id="iletisim" className="py-20 bg-gradient-to-br from-blue-900/20 via-dark-950 to-cyan-900/20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">Fiber Optik Projeniz İçin Teklif Alın</h2>
            <p className="text-xl text-gray-300 mb-8">Uzman ekibimiz 24 saat içinde size ulaşır</p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a href="tel:+905537165561" className="inline-flex items-center gap-2 px-8 py-4 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-all duration-300 font-semibold text-lg shadow-lg shadow-blue-500/30 whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line"></i>+90 553 716 55 61
              </a>
              <a href="https://wa.me/905537165561" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-all duration-300 font-semibold text-lg shadow-lg shadow-emerald-500/30 whitespace-nowrap cursor-pointer">
                <i className="ri-whatsapp-line"></i>WhatsApp ile Yaz
              </a>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingButtons />
      </div>
    </>
  );
}
